import { cva } from '@/styled-system/css';

export const inputRecipe = cva({
  base: {
    'backgroundColor': {
      base: 'Input.bg.default',
    },
    'color': { base: 'Input.text.populated' },
    'cursor': 'text',
    'boxShadow': {
      base: 'inset 0 0 0 {borderWidths.Input.default} var(--shadow-color)',
    },
    'boxShadowColor': {
      base: 'Input.border.default',
    },
    'textStyle': 'body',
    'width': '100%',
    '_placeholder': {
      color: { base: 'Input.text.placeholder' },
    },
    '&.edge-autofilled, &:-webkit-autofill, &:autofill': {
      // Override user agent stylesheet autofill background
      // This also preserves the border color
      boxShadow: {
        base: 'inset 0 0 0 {borderWidths.Input.default} var(--shadow-color), inset 0 0 0 1000px {colors.Input.bg.default}',
      },
    },
    'transition': {
      _motionReduce: 'none',
      _motionSafe: 'box-shadow 200ms ease,',
    },
  },
  variants: {
    disabled: {
      true: {
        opacity: 'disabled',
        cursor: 'default',
      },
      false: {
        'backgroundColor': {
          _hover: 'Input.bg.hover',
          _focus: 'Input.bg.active',
          _active: 'Input.bg.active',
        },
        '&.edge-autofilled, &:-webkit-autofill, &:autofill': {
          // Override user agent stylesheet autofill background
          // This also preserves the border color
          boxShadow: {
            _hover:
              'inset 0 0 0 {borderWidths.Input.default} var(--shadow-color), inset 0 0 0 1000px {colors.Input.bg.hover}',
            _focus:
              'inset 0 0 0 {borderWidths.Input.default} var(--shadow-color), {shadows.focus}, inset 0 0 0 1000px {colors.Input.bg.active}',
            _active:
              'inset 0 0 0 {borderWidths.Input.default} var(--shadow-color), inset 0 0 0 1000px {colors.Input.bg.active}',
          },
        },
        'boxShadow': {
          _focusVisible:
            'inset 0 0 0 {borderWidths.Input.default} var(--shadow-color), {shadows.focus}',
        },
        'boxShadowColor': {
          _hover: 'Input.border.hover',
          _focus: 'Input.border.active',
          _active: 'Input.border.active',
        },
        '&:is(:hover:active), &:is(:hover:focus)': {
          backgroundColor: 'Input.bg.activeHover',
        },
      },
    },
    error: {
      true: {
        backgroundColor: {
          base: 'Input.bg.error',
        },
        boxShadowColor: {
          base: 'Input.border.error',
        },
      },
      false: {},
    },
    fluid: {
      true: {},
      false: {
        width: 'auto',
      },
    },
    readOnly: {
      true: {
        backgroundColor: 'Input.bg.readOnly',
        boxShadowColor: 'border.invisible',
      },
      false: {},
    },
    size: {
      sm: {
        borderRadius: 'Input.sm',
        paddingBlock: 'Input.sm.padding.vert',
        paddingInline: 'Input.sm.padding.horz',
      },
      md: {
        borderRadius: 'Input.md.default',
        paddingBlock: 'Input.md.padding.vert',
        paddingInline: 'Input.md.padding.horz',
      },
      lg: {
        borderRadius: 'Input.lg.default',
        paddingBlock: 'Input.lg.padding.vert',
        paddingInline: 'Input.lg.padding.horz',
      },
    },
  },
  compoundVariants: [
    {
      size: 'sm',
      readOnly: true,
      css: {
        paddingInline: 'Input.sm.padding.horz-readOnly',
      },
    },
    {
      size: 'md',
      readOnly: true,
      css: {
        paddingInline: 'Input.md.padding.horz-readOnly',
      },
    },
    {
      size: 'lg',
      readOnly: true,
      css: {
        paddingInline: 'Input.lg.padding.horz-readOnly',
      },
    },
    {
      disabled: false,
      error: true,
      css: {
        'backgroundColor': {
          _hover: 'Input.bg.errorHover',
          _active: 'Input.bg.errorActive',
          _focus: 'Input.bg.errorActive',
        },
        'boxShadowColor': {
          _active: 'Input.border.errorActive',
          _focus: 'Input.border.errorActive',
          _hover: 'Input.border.errorHover',
        },
        '&.edge-autofilled, &:-webkit-autofill, &:autofill': {
          // Override user agent stylesheet autofill background
          // This also preserves the border color
          boxShadow: {
            _hover:
              'inset 0 0 0 {borderWidths.Input.default} var(--shadow-color), inset 0 0 0 1000px {colors.Input.bg.errorHover}',
            _focus:
              'inset 0 0 0 {borderWidths.Input.default} var(--shadow-color), {shadows.focus}, inset 0 0 0 1000px {colors.Input.bg.errorActive}',
            _active:
              'inset 0 0 0 {borderWidths.Input.default} var(--shadow-color), inset 0 0 0 1000px {colors.Input.bg.errorActive}',
          },
        },
        '&:is(:hover:active)': {
          backgroundColor: 'Input.bg.errorHover',
        },
      },
    },
    {
      disabled: false,
      readOnly: true,
      css: {
        backgroundColor: {
          _active: 'Input.bg.readOnly',
          _focus: 'Input.bg.readOnly',
          _hover: 'Input.bg.readOnly',
        },
      },
    },
  ],
});
